import React from 'react';

let names = []
let defaultValue = 'Any'

export default class Gender extends React.Component {
  constructor() {    
    super();     
    this.state = {
      gender: '',
      selected: ''
    }    
  }

  componentDidMount(){
    names.push(this.props.fields.name.value)
    if(this.props.fields.name.value === defaultValue){
      this.setState({ gender: defaultValue, selected: defaultValue }, () => {
        this.props.onChange(this.state);
      })
    } 
  }

  changeHandler = (e) => {
    this.setState({ gender: e.target.value, selected: e.target.value }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state);
      }
    });
  }

  render() {    
    return (
        <div className="gender" id={this.props.fields.name.value}>
          <label>
            <input 
              type="radio" 
              name="gender"
              checked={this.props.selected === this.props.fields.name.value}
              id={this.props.fields.name.value}   
              data-ref={'ref_'+this.props.fields.name.value}           
              value={this.props.fields.name.value}
              onChange={this.changeHandler.bind(this)}
              //data-active={this.state.activeState}
              />
              {this.props.fields.name.value}
            </label>
        </div>
    )
  }
}
